export default function Event({ title, imgSrc, url }) {
  return (
    <div className="col-4">
      <div className="d-flex flex-column gap-2">
        <img
          src={imgSrc}
          alt={'Thumbnail image for the ' + title + ' event.'}
          className="rounded"
        />

        <div>
          <h4 className="label-2 text-primary text-truncate">{title}</h4>
          <a
            href={url}
            title={'Click to view more details about the ' + title + ' event.'}
            className="btn btn-link btn-sm"
          >
            View Details
          </a>
        </div>
      </div>
    </div>
  );
}